import { CommonModule, DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

export interface CancelReservationConfirmationModalComponentData {
  reservationId: string;
  createdDate: Date;
  cancelDate: Date;
}

@Component({
  selector: 'app-cancel-reservation-confirmation-dialog',
  templateUrl: './cancel-reservation-confirmation-dialog.component.html',
  styleUrls: ['./cancel-reservation-confirmation-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatDialogModule,
    MatButtonModule, 
    MatIcon,
    DatePipe
  ]
})
export class CancelReservationConfirmationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<CancelReservationConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CancelReservationConfirmationModalComponentData
  ) { }

  onActionClick(action: boolean): void {
    this.dialogRef.close(action);
  }
}